window.bz_session_module = angular.module('bzSessionModule', [])
